module.exports = __webpack_public_path__ + "r-v3/img/arrowLineThickLeft_gray.ac91c024.svg";